import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
  rank?: number;
}

export default function MovieCard({ movie, rank }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/60 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-primary-400/70"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={movie.cover}
          alt={`${movie.title}封面`}
          title={`${movie.title} ${movie.genres.join(" ")}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80" />
        {typeof rank === "number" && (
          <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-md bg-accent-500 font-heading text-sm font-bold text-background-50">
            {rank}
          </span>
        )}
        <span className="absolute right-2 top-2 rounded-md bg-black/60 px-2 py-0.5 font-heading text-xs font-semibold text-accent-300">
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-2 left-2 right-2 flex flex-wrap gap-1">
          <span className="rounded bg-primary-500/90 px-1.5 py-0.5 text-[11px] text-background-50">{movie.typeLabel}</span>
          {movie.genres.slice(0, 1).map((g) => (
            <span key={g} className="rounded bg-black/50 px-1.5 py-0.5 text-[11px] text-foreground-800">
              {g}
            </span>
          ))}
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-400">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.year} · {movie.region}
        </p>
      </div>
    </Link>
  );
}